
import Vue from 'vue';
import TeeTimeAvailabilityIndex from '../components/tee_time_availability/TeeTimeAvailability.vue';
Vue.component('tee-time-availability-index', TeeTimeAvailabilityIndex);

export default Vue.extend({
  components: { TeeTimeAvailabilityIndex },
});
